import React, { useState } from "react";
import { Trans } from "react-i18next";
function PDFvalidado({ src, className, onClick }) {
  const [validada, setValidada] = useState(true);
  return (
    <>
      {validada ? (
        <embed
          src={src}
          //src={"zzz"}
          type="application/pdf"
          onClick={onClick}
          onError={() => setValidada(false)}
          className={className}
        ></embed>
      ) : (
        <div className="text-center font-bold text-nimbusLight !text-base p-2 max-w-[9rem] bg-white rounded-lg mx-auto m-4">
          <Trans i18nKey={"resourceNotFound"}></Trans>
        </div>
      )}
    </>
  );
}

PDFvalidado.defaultProps = {
  src: "",
  className: "",
  onClick: undefined,
};

export default PDFvalidado;
